import { render, staticRenderFns } from "./LeadFlowBoard.vue?vue&type=template&id=64c1d440&"
import script from "./LeadFlowBoard.vue?vue&type=script&lang=js&"
export * from "./LeadFlowBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports